const jobs = {
  forms: {
    information: {
      reservationDetails: {
        fields: {
          from: 'Pickup Location',
          to: 'Delivery Location',
          seat: 'Packages',
        },
      },
    },
  },

  table: {
    headers: {
      seats: 'Item Quantity',
      from: 'Pickup Location',
      to: 'Delivery Location',
      passenger: 'Recipient Name',
    },
    statuses: {
      picked: 'Out for Delivery',
      dropped: 'Delivered',
      noshow: 'Failed Delivery',
    },
  },
};

export default jobs;
